import { atom } from '@reatom/framework'
import { useAction, useAtom } from '@reatom/npm-react'
import { useEffect } from 'react'

import { pairFocusEvent } from '@root/entities/pair'
import { openSearchModalEvent } from '@root/features/services/search-pair'

import { SearchDrawer } from './search-drawer'

import type { Pair } from '@root/entities/pair'

const searchDrawerOpenAtom = atom(false, 'searchDrawerOpenAtom')

export const SearchDrawerController: React.FC = () => {
  const [open, setOpen] = useAtom(searchDrawerOpenAtom)
  const changeSelectedPair = useAction(pairFocusEvent)

  const handlePairSelected = (pair: Pair.PairMinimal) => {
    changeSelectedPair({
      network: pair.network,
      address: pair.address,
    })
    setOpen(false)
  }

  useEffect(() => {
    const unsubscribe = openSearchModalEvent.onCall((ctx) => {
      searchDrawerOpenAtom(ctx, true)
    })
    return () => unsubscribe()
  })

  return (
    <SearchDrawer
      open={open}
      onOpenChange={setOpen}
      onPairSelected={handlePairSelected}
    />
  )
}
